import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Search, Shield, Users, Lock, UserCog } from "lucide-react";

interface RoleFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statistics: {
    totalRoles: number;
    activeRoles: number;
    totalUsers: number;
    systemRoles?: number;
    customRoles?: number;
  };
}

export function RoleFilters({
  searchQuery,
  onSearchChange,
  statistics,
}: RoleFiltersProps) {
  return (
    <>
      {/* Estadísticas */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Total Roles</p>
                <p className="text-2xl font-bold text-slate-900">
                  {statistics.totalRoles}
                </p>
              </div>
              <Shield className="h-8 w-8 text-blue-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Roles Personalizados</p>
                <p className="text-2xl font-bold text-indigo-600">
                  {statistics.customRoles || 0}
                </p>
              </div>
              <UserCog className="h-8 w-8 text-indigo-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Roles del Sistema</p>
                <p className="text-2xl font-bold text-orange-600">
                  {statistics.systemRoles || 0}
                </p>
              </div>
              <Lock className="h-8 w-8 text-orange-500" />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-xs text-slate-600">Total Usuarios</p>
                <p className="text-2xl font-bold text-purple-600">
                  {statistics.totalUsers}
                </p>
              </div>
              <Users className="h-8 w-8 text-purple-500" />
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Filtros */}
      <Card className="mt-4">
        <CardContent className="p-4">
          <div className="flex flex-col md:flex-row gap-4">
            {/* Buscador */}
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <Input
                placeholder="Buscar por nombre o descripción..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="pl-10"
                aria-label="Buscar roles"
              />
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
}
